export default "__VITE_ASSET__17287a66__"